import { Enterprise } from './Enterprise';

import { OrgManager } from './OrgManager';
import { OrgMember } from './OrgMember';
import { PaginatedResponse } from './PaginatedResponse';
import { type SchedulingInstancePermissionData } from './SchedulingInstance';

export const ORG_MEMBER = 'ORG_MEMBER';
export const ORG_MANAGER = 'ORG_MANAGER';

export type SqspUserType = typeof ORG_MEMBER | typeof ORG_MANAGER;

export type OrgUserStatus = 'SENT' | 'ACCEPTED' | 'CANCELED' | 'EXPIRED' | null;

export interface SqspUserBaseProperties<T> {
  id: number;
  name: string;
  email: string;
  role: T;
  status: OrgUserStatus;
  dateAdded: string;
  squarespaceMemberId: string;
  inviteCode: string | null;
  permissions?: SchedulingInstancePermissionData;
}

export type SqspUserBase<K, V = void> = V extends void ? SqspUserBaseProperties<K> : SqspUserBaseProperties<K> & V;

// Current User will be of type SqspUser with enterprise
export type SqspUser = (OrgMember | OrgManager) & {
  enterprise: Enterprise;
};

// Org User will be the list of users on the Users tab
export type OrgUser = OrgMember | OrgManager;

// TODO: This is the type we will want for the Scheduling Instance Users UI / table
export type SchedulingInstanceOrgUser = OrgUser & {
  permissions: string;
};

export interface OrgUserFetchResponse extends PaginatedResponse {
  data: OrgUser[];
}

export type PendingMigrationUser = Partial<OrgUser> & {
  role: typeof ORG_MEMBER | typeof ORG_MANAGER;
};

export interface PendingMigrationUsersFetchResponse extends PaginatedResponse {
  data: PendingMigrationUser[];
}
